// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* This is to overide grapejs */
:root {
  --gjs-main-color: #ffffff;
  --gjs-primary-color: #ffffff;
  --gjs-secondary-color: #ddd;
  --gjs-tertiary-color: #804f7b;
  --gjs-quaternary-color: #d278c9;
  --gjs-font-color: #ddd;
  --gjs-font-color-active: #f8f8f8;
  --gjs-main-dark-color: rgba(0, 0, 0, 0.2);
  --gjs-secondary-dark-color: rgba(0, 0, 0, 0.1);
  --gjs-main-light-color: rgba(255, 255, 255, 0.1);
  --gjs-secondary-light-color: rgba(255, 255, 255, 0.7);
  --gjs-soft-light-color: rgba(255, 255, 255, 0.015);
  --gjs-color-blue: #3b97e3;
  --gjs-color-red: #dd3636;
  --gjs-color-yellow: #ffca6f;
  --gjs-color-green: #62c462;
  --gjs-left-width: 15%;
  --gjs-color-highlight: #71b7f1;
  --gjs-color-warn: #ffca6f;
  --gjs-handle-margin: -5px;
  --gjs-light-border: rgba(255, 255, 255, 0.05);
  --gjs-arrow-color: rgba(255, 255, 255, 0.7);
  --gjs-dark-text-shadow: rgba(0, 0, 0, 0.2);
  --gjs-color-input-padding: 22px;
  --gjs-input-padding: 5px;
  --gjs-padding-elem-classmanager: 5px 6px;
  --gjs-upload-padding: 150px 10px;
  --gjs-animation-duration: 0.2s;
  --gjs-main-font: Helvetica, sans-serif;
  --gjs-font-size: 0.75rem;
  --gjs-placeholder-background-color: var(--gjs-color-green);
  --gjs-canvas-top: 40px;
  --gjs-flex-item-gap: 5px;
}

body {
  overflow: hidden;
}

#root {
  width: 100%;
}

.gjs-cv-canvas {
  width: 100%;
  top: 0;
  height: 100%;
}

.gjs-sm-properties,
.gjs-clm-tags,
.gjs-sm-sector-title,
.gjs-one-bg {
  background-color: #4a5565;
}
`, "",{"version":3,"sources":["webpack://./src/components/GrapesjsEditor/ModalEditor/style.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;EAC7B,+BAA+B;EAC/B,sBAAsB;EACtB,gCAAgC;EAChC,yCAAyC;EACzC,8CAA8C;EAC9C,gDAAgD;EAChD,qDAAqD;EACrD,kDAAkD;EAClD,yBAAyB;EACzB,wBAAwB;EACxB,2BAA2B;EAC3B,0BAA0B;EAC1B,qBAAqB;EACrB,8BAA8B;EAC9B,yBAAyB;EACzB,yBAAyB;EACzB,6CAA6C;EAC7C,2CAA2C;EAC3C,0CAA0C;EAC1C,+BAA+B;EAC/B,wBAAwB;EACxB,wCAAwC;EACxC,gCAAgC;EAChC,8BAA8B;EAC9B,sCAAsC;EACtC,wBAAwB;EACxB,0DAA0D;EAC1D,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,MAAM;EACN,YAAY;AACd;;AAEA;;;;EAIE,yBAAyB;AAC3B","sourcesContent":["/* This is to overide grapejs */\n:root {\n  --gjs-main-color: #ffffff;\n  --gjs-primary-color: #ffffff;\n  --gjs-secondary-color: #ddd;\n  --gjs-tertiary-color: #804f7b;\n  --gjs-quaternary-color: #d278c9;\n  --gjs-font-color: #ddd;\n  --gjs-font-color-active: #f8f8f8;\n  --gjs-main-dark-color: rgba(0, 0, 0, 0.2);\n  --gjs-secondary-dark-color: rgba(0, 0, 0, 0.1);\n  --gjs-main-light-color: rgba(255, 255, 255, 0.1);\n  --gjs-secondary-light-color: rgba(255, 255, 255, 0.7);\n  --gjs-soft-light-color: rgba(255, 255, 255, 0.015);\n  --gjs-color-blue: #3b97e3;\n  --gjs-color-red: #dd3636;\n  --gjs-color-yellow: #ffca6f;\n  --gjs-color-green: #62c462;\n  --gjs-left-width: 15%;\n  --gjs-color-highlight: #71b7f1;\n  --gjs-color-warn: #ffca6f;\n  --gjs-handle-margin: -5px;\n  --gjs-light-border: rgba(255, 255, 255, 0.05);\n  --gjs-arrow-color: rgba(255, 255, 255, 0.7);\n  --gjs-dark-text-shadow: rgba(0, 0, 0, 0.2);\n  --gjs-color-input-padding: 22px;\n  --gjs-input-padding: 5px;\n  --gjs-padding-elem-classmanager: 5px 6px;\n  --gjs-upload-padding: 150px 10px;\n  --gjs-animation-duration: 0.2s;\n  --gjs-main-font: Helvetica, sans-serif;\n  --gjs-font-size: 0.75rem;\n  --gjs-placeholder-background-color: var(--gjs-color-green);\n  --gjs-canvas-top: 40px;\n  --gjs-flex-item-gap: 5px;\n}\n\nbody {\n  overflow: hidden;\n}\n\n#root {\n  width: 100%;\n}\n\n.gjs-cv-canvas {\n  width: 100%;\n  top: 0;\n  height: 100%;\n}\n\n.gjs-sm-properties,\n.gjs-clm-tags,\n.gjs-sm-sector-title,\n.gjs-one-bg {\n  background-color: #4a5565;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
